import { useMemo } from 'react';
import { useCallback, useContext } from 'preact/compat';
import { visitorCount } from '@genericBookings/visitorUtils';
function useQueryParams(options) {
    const currUrl = new URL(window.location.href);
    const params = currUrl.searchParams;
    const { isMulti, } = useContext(options);
    const visitors = useMemo(() => {
        const currVisitors = {};
        Array(9).fill(0).forEach((_, idx) => {
            const visitor = params.get(`Visitors${idx}`);
            currVisitors[`Visitors${idx}`] = visitor ? parseInt(visitor, 10) : 0;
        });
        return visitorCount(currVisitors) > 0 ? currVisitors : null;
    }, [params]);
    const convertSessions = useCallback(() => {
        if (isMulti) {
            return JSON.parse(params.get('Sessions') ?? '[]');
        }
        return null;
    }, [isMulti, params]);
    return useMemo(() => ({
        visitDate: params.get('VisitDate'),
        dayTicketId: params.get('DayTicketId') ? parseInt(params.get('DayTicketId') ?? '0', 10) : null,
        productId: params.get('ProductId') ? parseInt(params.get('ProductId') ?? '0', 10) : null,
        sessions: convertSessions(),
        sessionId: params.get('session') ? parseInt(params.get('session') ?? '0', 10) : null,
        visitors,
        visitorCount: visitors !== null ? visitorCount(visitors) : 0,
    }), [isMulti, params, visitors]);
}
export default useQueryParams;
